/**
 * 画像なければ、ダミー画像を表示
 */
function imgFallback(selector, fallbackImageUrl){
	var nodelist = document.querySelectorAll(selector);
	var node = Array.prototype.slice.call(nodelist,0);
	node.forEach(function(image, index){
		var imageObj = new Image();
		imageObj.src = image.src;
		imageObj.onerror = function(){
			imageObj.onerror = null;
			image.src = fallbackImageUrl;
		}
	});
}
window.addEventListener('DOMContentLoaded', function(){
	imgFallback('.js-img-fallback', '/themes/zaidan/dest/images/common/dummy_image_book.png');
});